import { vec3 } from 'gl-matrix';

const PLAYER_COLLIDER_NAMES = ['PhysicsBody', 'PhysicsLeftHand', 'PhysicsRightHand', 'PhysicsHead']

export let canShoot = true;

export function setShootingEnabled(b) {
  canShoot = b;
}

function isPlayerColliderName(name) {
  if (PLAYER_COLLIDER_NAMES.includes(name)) {
    return name;
  } else {
    return false;
  }
}

WL.registerComponent('gun', {
  colyseusObj: {
    type: WL.Type.Object
  },
  spawnerObj: {
    type: WL.Type.Object
  },
  gun: {
    type: WL.Type.Object
  },
  gunSFX: {
    type: WL.Type.Object
  },
  center: {
    type: WL.Type.Object
  },
  target: {
    type: WL.Type.Object
  },
  visualFeeback: {
    type: WL.Type.Object
  },
  bullet: {
    type: WL.Type.Object
  },
  handedness: {
    type: WL.Type.String
  },
  muzzleFlash: {
    type: WL.Type.Object
  }
}, {
  init: function() {
    this.shotFired = false;
  },
  start: function() {
    this.intersectObject = '';
    this.gunDirection = vec3.create();
    this.gunOrigin = vec3.create();
    this.gunTarget = vec3.create();
    this.muzzleFlashMesh = this.muzzleFlash.getComponent('mesh');
    this.sound = this.gunSFX.getComponent('gunshot-sfx');
    this.visualBullet = this.bullet.getComponent('bullet');
    this.colyseus = this.colyseusObj.getComponent('colyseus');
    this.hitRelayer = this.spawnerObj.getComponent('hit-relayer');
    this.vsFb = this.visualFeeback.getComponent('hitmarker');
    this.muzzleFlashMesh.active = false;

    if (this.handedness == "right") {
      PP.RightGamepad.registerButtonEventListener(PP.ButtonType.SELECT, PP.ButtonEvent.PRESS_START, 'shoot', button => {
        this.physXRaycast();
      });
    }
    if (this.handedness == "left") {
      PP.LeftGamepad.registerButtonEventListener(PP.ButtonType.SELECT, PP.ButtonEvent.PRESS_START, 'shoot', button => {
        this.physXRaycast();
      });
    }
  },
  physXRaycast: function() {
    if (this.shotFired || !canShoot) return;
    this.sound.pulse();

    this.muzzleFlashMesh.active = true;
    setTimeout(() => {
      this.muzzleFlashMesh.active = false;
    }, 100);

    this.shotFired = true;

    this.center.getTranslationWorld(this.gunOrigin);
    this.target.getTranslationWorld(this.gunTarget);
    vec3.subtract(this.gunDirection, this.gunTarget, this.gunOrigin);
    vec3.normalize(this.gunDirection, this.gunDirection);

    const raycastHits = WL.physics.rayCast(this.gunOrigin, this.gunDirection, 255, 255);
    const [x2, y2, z2] = this.gunOrigin;

    if (raycastHits.hitCount) {
      let targets = raycastHits.objects;
      let target = "";
      if (isPlayerColliderName(targets[0].name)) {
        this.vsFb.showHitmarker(raycastHits.locations[0]);
        setTimeout(() => {this.vsFb.hideHitmarker()}, 125);

        let enemy = targets[0].parent;
        let id = this.colyseus.getIdByName(enemy.getComponent('peer-networked-player').name)
        target = targets[0].name;

        switch (target) {
          case 'PhysicsBody':
            target = (`${id}|body`);
            break;
          case 'PhysicsLeftHand':
            target = (`${id}|leftHand`);
            break;
          case 'PhysicsRightHand':
            target = (`${id}|rightHand`);
            break;
          case 'PhysicsHead':
            target = (`${id}|head`);
            break;
        }
      } else if (targets[0].name === 'PracticeTarget') {
        const rails = targets[0].parent.getComponent('rail-system');
        setTimeout(() => {
          rails.changePath();
          rails.updateCount();
        }, 100);
      }
      if (this.visualBullet.isFlying) this.visualBullet.reset();
      this.visualBullet.shoot(this.gunOrigin, raycastHits.locations[0], raycastHits.distances[0]);
      this.colyseus.room.send('shoot', {
        obj: target,
        shotOrigin: {
          x: x2,
          y: y2,
          z: z2
        },
        destination: {
          x: raycastHits.locations[0][0],
          y: raycastHits.locations[0][1],
          z: raycastHits.locations[0][2]
        },
        distance: raycastHits.distances[0]
      });
    }
    setTimeout(() => {
      this.shotFired = false;
      this.gun.resetTranslation();
    }, 150);
  },
  update: function(dt) {
    if (this.shotFired) this.gun.translateObject([-0.0125, 0, 0]);
  }
});
